import AP from "../../legacy/global";

export const TOOLS_FLAG = {
  SHOW_QUOTE_BRIDGE: "tools-quote-bridge"
};
export const EXTENSIONS_DETAILS = [
  {
    ID: "kgijfidbbkjlhmibgnjlnobaobkcbenb",
    THUMBNAIL: "/assets/images/QuoteBridgeBadge.png",
    IMAGE: "/assets/images/QuoteBridgeFeaturedImage.png",
    IMAGE_CLASS: "large",
    NAME: "Quote Bridge",
    OVERVIEW: [
      {
        subtitle: "Integrate your quotes to the SageSure Agent Portal",
        content:
          "With Quote Bridge, there’s no need to start a quote from scratch. You can automatically have your quotes imported into the SageSure Agent Portal."
      },
      {
        content:
          "Look for a subtle notification to let you know that Quote Bridge has detected a quote that can be exported and send it to SageSure with just one click."
      }
    ],
    SHOW_TOOLS_FLAG: TOOLS_FLAG.SHOW_QUOTE_BRIDGE,
    URL: AP.config?.envConfig.ipcm.values.quoteBridgeExtensionUrl,
    mixpanelEvent: "Install Quote Bridge",
    browserRequirements: "Google Chrome V16.0.912+"
  }
];
